import comp from "./EmojiPicker";
export default comp;
